import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-beak-subscription',
  templateUrl: './beak-subscription.component.html',
  styleUrls: ['./beak-subscription.component.css']
})
export class BeakSubscriptionComponent implements OnInit {

  dataSource:any[];
  userStatus:string = "Active";
  displayedColumns:string[];
  loading:boolean = true;
  total:number;
  color = 'primary';
  mode = 'indeterminate';
  value = 75;
  diameter=60

  exampleObj = [{
    fullName:"TestFullName",
    companyName: "TestCompanyName",
    email: "test@test.com",
    phoneNumber: "1234567890",
    createdDateString: `${new Date().toDateString()}`,
    statusString: "Active"
  },
    {
      fullName:"Lucius Fox",
      companyName: "Wayne Enterprises",
      email: "lufox@wayne.com",
      phoneNumber: "8768768768",
      createdDateString: `${new Date().toDateString()}`,
      statusString: "Active"
    }]

  constructor(private router:Router) { }

  ngOnInit(): void {
    this.displayedColumns = [ 'no','name', 'company', 'mobile','email', 'registereddate','status','tool'];
    this.loading = false;
    this.dataSource = this.exampleObj;
    // this.total = 0;
  }

  OnEditClick(id:any){
    // console.log("edit button clicked");
    this.router.navigate([`/beak-customer/${id}`],);
  }

  DeActivateCustomer(id:any){
    // console.log("Deactivate customer clicked !");
  }

  OnStatusChange(){
    // console.log("Status changed");
  }

  DeleteCustomer(id:any){
    // console.log("Delete customer clicked !")
  }
}
